{
  "account.add_or_remove_from_list": "Tinye ma ọ bụ Wepu na ndepụta",
  "account.badges.bot": "Bot",
  "account.badges.group": "Otù",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.follow": "Soro",
  "account.followers": "Ndị na-eso",
  "account.following": "Na-eso",
  "account.go_to_profile": "Jee na profaịlụ",
  "account.mute": "Mee ogbi @{name}",
  "account.posts": "Edemede",
  "account.unfollow": "Kwụsị iso",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.retention.cohort_size": "Ojiarụ ọhụrụ",
  "annual_report.summary.new_posts.new_posts": "edemede ọhụrụ",
  "audio.hide": "Zoo ụda",
  "bundle_column_error.retry": "Nwaa ọzọ",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Mechie",
  "bundle_modal_error.retry": "Nwaa ọzọ",
  "column.about": "Maka",
  "column.blocks": "Ojiarụ egbochiri",
  "column.bookmarks": "Ebenrụtụakā",
  "column.home": "Be",
  "column.lists": "Ndepụta",
  "column.notifications": "Nziọkwà",
  "column.pins": "Pinned post",
  "column_header.pin": "Gbado na profaịlụ gị",
  "column_header.show_settings": "Gosi mwube",
  "community.column_settings.media_only": "Media only",
  "compose.language.change": "Gbanwee asụsụ",
  "compose.language.search": "Chọọ asụsụ...",
  "compose.published.open": "Mepe",
  "compose_form.direct_message_warning_learn_more": "Mụtakwuo",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.reply": "Zaa",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmation_modal.cancel": "Kagbuo",
  "confirmations.delete.confirm": "Hichapụ",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete_list.confirm": "Hichapụ",
  "confirmations.mute.confirm": "Mee ogbi",
  "confirmations.unfollow.confirm": "Kwụsị iso",
  "conversation.delete": "Hichapụ nkata",
  "conversation.open": "Lelee nkata",
  "disabled_account_banner.account_settings": "Mwube akaụntụ",
  "domain_pill.username": "Ahaojiaru",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "emoji_button.activity": "Mmemme",
  "emoji_button.food": "Oriri & Ọṅụṅụ",
  "emoji_button.label": "Tibanye emoji",
  "emoji_button.people": "Mmadụ",
  "emoji_button.search": "Chọọ...",
  "emoji_button.symbols": "Ọdịmara",
  "empty_column.account_timeline": "No posts found",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "errors.unexpected_crash.report_issue": "Kpesa nsogbu",
  "explore.trending_links": "Akụkọ",
  "filter_modal.added.review_and_configure_title": "Mwube myọ",
  "firehose.all": "Ha niine",
  "follow_request.authorize": "Nye ikike",
  "follow_suggestions.view_all": "Lelee ha ncha",
  "footer.privacy_policy": "Iwu nzuzu",
  "getting_started.heading": "Mbido",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "home.column_settings.show_replies": "Gosi nzaghachị",
  "home.hide_announcements": "Zoo ọkwa",
  "home.show_announcements": "Gosi ọkwa",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "Mepe profaịlụ gị",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned posts list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new post",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "Mechie",
  "lists.delete": "Hichapụ ndepụta",
  "lists.edit": "Dezie ndepụta",
  "navigation_bar.about": "Maka",
  "navigation_bar.bookmarks": "Ebenrụtụakā",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.favourites": "Mmasị",
  "navigation_bar.lists": "Ndepụta",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.status": "Edemede ọhụrụ:",
  "privacy.change": "Adjust status privacy",
  "relative_time.full.just_now": "kịta",
  "relative_time.just_now": "kịta",
  "relative_time.today": "taa",
  "reply_indicator.cancel": "Kagbuo",
  "report.categories.other": "Ọzọ",
  "report.categories.spam": "Nzipụ Ozièlètrọniìk Nkeāchọghị",
  "report.category.title_account": "profaịlụ",
  "report.mute": "Mee ogbi",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.other": "Ọzọ",
  "search.placeholder": "Chọọ",
  "search_results.accounts": "Profaịlụ",
  "server_banner.active_users": "ojiarụ dị ìrè",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.bookmark": "Kee ebenrụtụakā",
  "status.copy": "Copy link to status",
  "status.delete": "Hichapụ",
  "status.edit": "Dezie",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.remove_bookmark": "Wepu ebenrụtụakā",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Tụgharịa",
  "tabs_bar.home": "Be",
  "tabs_bar.notifications": "Nziọkwà",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Na-ewu ewu kịta",
  "upload_progress.label": "Uploading…"
}
